<template>
	<div>
		<el-drawer
			:title="`${data.partnerName} - 伙伴详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose"
			destroy-on-close>
			<div class="drawer-content">
				<!-- 标签页 -->
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="基础信息" name="1" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>基本信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="伙伴名称">
									{{ detailData.partnerName || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="伙伴类别">
									{{ detailData.partnerType || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="类型">
									{{ detailData.entityType || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="合作状态">
									<el-tag
										:type="detailData.status === '正常' ? 'success' : 'danger'"
										size="small"
										v-if="detailData.status">
										{{ detailData.status }}
									</el-tag>
									<span v-else>'--'</span>
								</el-descriptions-item>
								<el-descriptions-item label="联系人">
									{{ detailData.contactPerson || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="联系电话">
									{{ detailData.contactPhone || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="办公地址">
									{{ detailData.address || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="录入人员">
									{{ detailData.creator || '--' }}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>业务信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="业务标签" :span="2">
									<el-tag
										v-for="(tag, i) in detailData.businessTag"
										:key="i"
										:type="getRandomTagType(tag)"
										style="margin-right: 6px"
										size="small">
										{{ tag }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="评级等级">
									{{ detailData.rating || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="统一社会信用代码">
									{{ detailData.creditCode || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="法人代表">
									{{ detailData.legalPerson || '--' }}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>财务结算信息</span>
							</div>
							<el-descriptions :column="2" border>
								<el-descriptions-item label="开户行">
									{{ detailData.bankName || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="银行账号">
									{{ detailData.bankAccount || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="纳税人识别号">
									{{ detailData.taxNumber || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="保证金金额">
									{{ detailData.deposit || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="结算周期">
									{{ detailData.settlementCycle || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="结算方式">
									{{ detailData.settlementMethod || '--' }}
								</el-descriptions-item>
								<el-descriptions-item label="分成协议">
									{{ detailData.shareAgreement || '--' }}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-tab-pane>
					<el-tab-pane label="资质附件" name="2" lazy>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>企业资质</span>
							</div>
							<el-descriptions :column="1" border>
								<el-descriptions-item label="营业执照">
									<div class="img-item">
										<el-image class="imgs"></el-image>
										<div class="name">
											<div>营业执照.pdf</div>
											<el-button type="primary" size="small">查看</el-button>
										</div>
									</div>
								</el-descriptions-item>
								<el-descriptions-item label="行业许可证">
									<div class="img-item">
										<el-image class="imgs"></el-image>
										<div class="name">
											<div>行业许可证.pdf</div>
											<el-button type="primary" size="small">查看</el-button>
										</div>
									</div>
								</el-descriptions-item>
								<el-descriptions-item label="法人身份证">
									<div class="img-item">
										<el-image class="imgs"></el-image>
										<div class="name">
											<div>法人身份证.pdf</div>
											<el-button type="primary" size="small">查看</el-button>
										</div>
									</div>
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
						<el-card class="table-card" shadow="always">
							<div slot="header" class="clearfix">
								<span>其他附件</span>
							</div>
							<el-empty description="暂无其他附件"></el-empty>
						</el-card>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		name: 'PartnerManagementDetailDrawer',
		components: {},
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.activeName = '1';
					});
				}
			},
		},
		data() {
			return {
				activeName: '1',
				detailData: {
					partnerName: '南京创新科技有限公司',
					partnerType: '租赁商',
					entityType: '公司',
					businessTag: ['创新租赁', '增值服务'],
					contactPerson: '张三',
					contactPhone: '13800138001',
					creator: 'admin',
					status: '正常',
				},
			};
		},
		methods: {
			getRandomTagType(str) {
				const tagTypes = ['success', 'info', 'primary'];
				let hash = 0;
				for (let i = 0; i < str.length; i++) {
					hash = str.charCodeAt(i) + ((hash << 5) - hash);
				}
				const index = Math.abs(hash) % tagTypes.length;
				return tagTypes[index];
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}

	.table-card {
		margin-bottom: 10px;
	}

	.img-item {
		width: 100%;
		display: flex;
		gap: 20px;
		.imgs {
			width: 180px;
			height: 100px;
		}
		.name {
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 20px;
			font-size: 14px;
		}
	}
</style>
